exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sk-three-bounce {\r\n    top: 50%;\r\n    position: relative;\r\n    margin: auto;\r\n    width: 80px;\r\n    text-align: center;\r\n}\r\n\r\n.sk-three-bounce .sk-child {\r\n    width: 20px;\r\n    height: 20px;\r\n    border-radius: 100%;\r\n    display: inline-block;\r\n    animation: sk-three-bounce 1.4s ease-in-out 0s infinite both;\r\n}\r\n\r\n.sk-three-bounce .sk-bounce1 {\r\n    animation-delay: -0.32s;\r\n}\r\n\r\n.sk-three-bounce .sk-bounce2 {\r\n    animation-delay: -0.16s;\r\n}\r\n\r\n@keyframes sk-three-bounce {\r\n    0%, 80%, 100% {\r\n        transform: scale(0);\r\n    }\r\n    40% {\r\n        transform: scale(1);\r\n    }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Empower360Plus/EmpowerWeb2.0/A4.Empower/A4.Empower/ClientApp/src/app/shared/spinner/spinkit-css/sk-three-bounce.css
// module id = ../../../../../src/app/shared/spinner/spinkit-css/sk-three-bounce.css
// module chunks = main